EsriLeaflet.FeatureLayer.include({

  legend: function(callback, context) {
    return this.service.legend(callback, context);
  }

});
